import { useMemo } from 'react';
import { useQuery } from 'react-apollo';

import { ResourceItemType } from '../types';
import GET_RESOURCES, { MultimediaResourcesReturn } from '../queries/get-resources';

const useResourceLibrary = (): SeparatedResources => {
  const { loading, data } = useQuery<MultimediaResourcesReturn>(GET_RESOURCES);

  const educationalContent: ResourceItemType[] = useMemo(() => {
    const multimediaResources = data?.multimediaResources ?? [];
    return multimediaResources.filter(({ resourceType }) => resourceType === 'educational_content');
  }, [data]);

  const blogsContent: ResourceItemType[] = useMemo(() => {
    const multimediaResources = data?.multimediaResources ?? [];
    return multimediaResources.filter(({ resourceType }) => resourceType === 'blogs');
  }, [data]);

  const videosContent: ResourceItemType[] = useMemo(() => {
    const multimediaResources = data?.multimediaResources ?? [];
    return multimediaResources.filter(({ resourceType }) => resourceType === 'videos');
  }, [data]);

  return {
    loading,
    educationalContent,
    blogsContent,
    videosContent
  };
};

type SeparatedResources = {
  loading: boolean;
  educationalContent: ResourceItemType[];
  blogsContent: ResourceItemType[];
  videosContent: ResourceItemType[];
};

export default useResourceLibrary;
